import React, { useEffect, useRef, useState } from 'react'
import ReactSelect from 'react-select'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { Loader, Modal } from 'rsuite';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { checkIsEmailValid, checkIsPhoneNumberValid } from '../../services/helper';
import { toast } from '../CommonComponents/ToastComponent/toast';
import { useDispatch } from 'react-redux';
import { checkContactLinkedWithMaster, checkExistingContactWithEmailOrPhone, createContact, getContactById, linkContactToSupplier, updateContact } from '../../redux/actions/contact';
import LoaderComponent from '../CommonComponents/LoaderComponent';
import LinkedContactSuppliers from './linkedContactSuppliers';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { parsePhoneNumber } from 'awesome-phonenumber'

const CreateContact = ({
    onClose,
    supplierId = null,
    contactId = null,
    isEdit = false,
    setIsRelaodContacts,
    contactDataFromField = {},
    listSupplierId = null,
    isInCalls = null,
    vendorInCallsDetailsId = null,
    emailEntered = '',
    activeEmailField,
    getContactsData,
    supplierName,
    activeTab,
    setShowModal,
    vendorInfo }) => {

    const columns = [
        { label: 'First Name', value: 'firstname' },
        { label: 'Status', value: 'status' },
        { label: 'Last Name', value: 'lastname' },
        { label: 'Title', value: 'title' },
        { label: 'Email', value: 'email', isRequired: true },
        { label: 'Pronunciation', value: 'pronunciation' },
        { label: 'Phone', value: 'phone', isRequired: true },
        { label: 'Pronouns', value: 'pronouns' }
    ]

    const statusOptions = [
        { value: true, label: 'Active' },
        { value: false, label: 'In-Active' }
    ]

    const pronounsOptions = [
        { value: 'he/him/his', label: 'He/Him/His' },
        { value: 'she/her/hers', label: 'She/Her/Hers' },
        { value: 'they/them/theirs', label: 'They/Them/Theirs' },
        { value: 'no-pronouns', label: 'No Pronouns (Name Only)' }
    ]

    const defaultValues = {
        firstname: '',
        lastname: '',
        email: emailEntered?.value || '',
        phone: '',
        title: '',
        status: {
            label: 'Active',
            value: true
        },
        pronunciation: '',
        pronouns: null,
        supplierId: null
    }

    const phoneInputRefname = useRef(null)
    const dispatch = useDispatch()
    const params = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [contactInfo, setContactInfo] = useState({})
    const [oldContactInfo, setOldContactInfo] = useState(defaultValues)
    const [isPhoneValid, setIsPhoneValid] = useState('')
    const [isValidatingPhone, setIsValidatingPhone] = useState(false)
    const [countryCode, setCountryCode] = useState('')
    const [isEmailValid, setIsEmailValid] = useState('')
    const [isValidatingEmail, setIsValidatingEmail] = useState(false)
    const [isEmailRisky, setIsEmailRisky] = useState('')
    const [isEmailContactExists, setIsEmailContactExists] = useState(false)
    const [isPhoneContactExists, setIsPhoneContactExists] = useState(false)
    const [showLinkModal, setShowLinkModal] = useState(false)
    const [newContactData, setNewContactData] = useState({})


    useEffect(() => {
        if (params?.contactId) {
            return
        }
        if (isEdit && contactId) {
            getContactDataById(contactId)
        } else {
            if (contactDataFromField && Object.keys(contactDataFromField)?.length > 0) {
                if (contactDataFromField.hasOwnProperty('colName') && contactDataFromField.hasOwnProperty('value')) {
                    defaultValues[contactDataFromField?.colName] = contactDataFromField?.value
                    if (contactDataFromField?.colName === 'phone') {
                        if (contactDataFromField?.value) {
                            handlePhoneNumberFocusOut(null, null, contactDataFromField?.value)
                        }
                    } else {
                        if (contactDataFromField?.value) {
                            handleEmailFocusOut(contactDataFromField?.value)
                        }
                    }
                } else {
                    Object.keys(contactDataFromField)?.map(key => {
                        defaultValues[key] = contactDataFromField?.[key]
                    })
                    if (defaultValues?.phone) {
                        handlePhoneNumberFocusOut(null, null, defaultValues?.phone)
                    }
                }
            }
            setContactInfo(defaultValues)
        }
    }, [contactId, isEdit])

    useEffect(() => {
        if (params?.contactId) {
            const contactId = params?.contactId
            getContactDataById(contactId)
        }
    }, [])

    const getPronounsValue = (contactData) => {
        if (contactData?.pronouns === 'he/him/his') {
            return { value: 'he/him/his', label: 'He/Him/His' }
        } else if (contactData?.pronouns === 'she/her/hers') {
            return { value: 'she/her/hers', label: 'She/Her/Hers' }
        } else if (contactData?.pronouns === 'they/them/theirs') {
            return { value: 'they/them/theirs', label: 'They/Them/Theirs' }
        } else if (contactData?.pronouns === 'no-pronouns') {
            return { value: 'no-pronouns', label: 'No Pronouns (Name Only)' }
        }
    }

    const handleChange = async (colName, value) => {
        if (colName === 'email') {
            setIsEmailContactExists(false)
            if (!value) {
                setIsEmailValid(true)
            } else {
                setIsEmailValid('')
            }
        }
        if (colName === 'status' && isEdit && contactId) {
            if (contactInfo?.status?.value) {
                try {
                    setIsLoading(true)
                    const result = await dispatch(checkContactLinkedWithMaster({ contactId }))
                    setIsLoading(false)
                    if (result?.isLinked) {
                        toast.show({
                            title: 'Danger',
                            description: 'Cannot deactivate a contact that is actively linked to a master supplier!'
                        })
                        return
                    }
                } catch (err) {
                    setIsLoading(false)
                    toast.show({
                        title: 'Warning',
                        description: err?.response?.data?.message || 'Failed to check that contact linked with master or not!'
                    })
                    return
                }
            }
        }
        setContactInfo({
            ...contactInfo,
            [colName]: value
        })
    }

    const handlePhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false, isRetry = false) => {
        if (!phoneValue) {
            toast.show({
                title: 'Warning',
                description: 'Please enter phone number!'
            })
            return
        }
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        const phoneNewValue = phoneValue ? '+' + phoneValue : phoneValue
        const phone = parsePhoneNumber(phoneNewValue);
        const isValid = phone?.valid || false
        if (!isValid) {
            setIsPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            setIsValidatingPhone(true)
            phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch, isRetry)
            setIsPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsPhoneValid(true)
        }
        if (isUseEffect) {
            setContactInfo({ ...contactInfo, 'phone': phoneValidationResult?.phoneNumber })
        }
    }

    const handlePhoneInputChange = (value, country, e, formattedValue) => {
        var phoneValue = formattedValue.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
        var countrycode = country.dialCode + ' '
        if (phoneValue !== '') {
            phoneValue = countrycode + phoneValue
            setIsPhoneValid('')
        } else {
            phoneValue = country.dialCode
            setIsPhoneValid(true)
        }
        if (e.target === null) {
            handlePhoneNumberFocusOut(e, country, formattedValue)
        }
        setCountryCode(country.dialCode)
        setContactInfo({
            ...contactInfo,
            'phone': phoneValue === '' ? '' : phoneValue,
        })
        setIsPhoneContactExists(false)
    }

    const handleEmailFocusOut = async (emailValue, isRetry = false, isCheckExists = true) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingEmail(true)
            if (isCheckExists) {
                if (oldContactInfo?.email !== contactInfo?.email) {
                    await checkExistingContact('email', emailValue)
                }
            }
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
            setIsEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
            setIsEmailRisky(emailValidationResult?.isEmailRisky)
        } else {
            setIsEmailValid(true)
        }
    }

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handleCancel = () => {
        if (isEdit && contactId) {
            setContactInfo(oldContactInfo)
        } else {
            setContactInfo(defaultValues)
        }
        setIsEmailContactExists(false)
        setIsPhoneContactExists(false)
        onClose()
    }


    const saveContactHandler = async (action) => {
        await dispatch(createContact({ contactInfo: newContactData, supplierId: supplierId || null, listSupplierId: vendorInfo?.id, isInCalls: vendorInfo?.isInCalls, vendorInCallsDetailsId: supplierId?.id ? null : (vendorInCallsDetailsId || null), linkToSupplier: action === 'link' ? true : false })).then(async (result) => {
            toast.show({
                title: 'Success',
                description: result?.message
            })
    
            await getContactsData()
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to create contact!'
            })
        })
        setShowModal(false)
        setShowLinkModal(false)
    }

    const handleSave = async () => {
        if (!contactInfo?.phone && !contactInfo?.email) {
            toast.show({
                title: 'Warning',
                description: 'Please add email or phone for contact!'
            })
            return
        }
        if (isPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }
        if (isEmailValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Please enter valid email!'
            })
            return
        }

        if (contactInfo?.phone && countryCode === contactInfo?.phone) {
            contactInfo['phone'] = ''
        }

        const contactData = { ...contactInfo, status: contactInfo?.status?.value, pronouns: contactInfo?.pronouns?.value || null }
        setNewContactData(contactData)

        if (activeTab !== 'emails') {
            if (((isEdit && contactId) || params?.contactId)) {
                dispatch(updateContact({ contactId: contactId || params?.contactId, contactData })).then(result => {
                    const contactData = { ...result?.data }
                    if (contactData?.status !== null) {
                        contactData.status = { label: contactData.status ? 'Active' : 'In-Active', value: contactData?.status }
                    } else {
                        contactData.status = { label: 'Active', value: true }
                    }
                    if (contactData?.pronouns) {
                        contactData.pronouns = getPronounsValue(contactData)
                    }
                    setContactInfo(contactData)
                    setOldContactInfo(contactData)
                    toast.show({
                        title: 'Success',
                        description: 'Contact updated successfully!'
                    })
                    setIsLoading(false)
                    if ((isEdit && contactId)) {
                        setIsRelaodContacts(true)
                        onClose()
                    }
                }).catch((err) => {
                    toast.show({
                        title: 'Warning',
                        description: err?.response?.data?.message || 'Failed to update contact!'
                    })
                    setIsLoading(false)
                })
            } else {
                dispatch(createContact({ contactInfo: contactData, supplierId, listSupplierId, isInCalls, vendorInCallsDetailsId, linkToSupplier: true })).then(result => {
                    toast.show({
                        title: 'Success',
                        description: 'Contact created successfully!'
                    })
                    onClose(null, true, result?.contact)
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to create contact!'
                    })
                })
            }
        } else {
            if (isEdit && contactId) {
                dispatch(updateContact({ contactId: contactId, contactData })).then(async (result) => {
                    await getContactsData()
                    toast.show({
                        title: 'Success',
                        description: 'Contact updated successfully!'
                    })
                    onClose(null, true, result?.data)
                }).catch((err) => {
                    toast.show({
                        title: 'Warning',
                        description: err?.response?.data?.message || 'Failed to update contact!'
                    })
                })
            } else {
                setShowLinkModal(true)
            }
        }
    }

    const checkExistingContact = async (type, value) => {
        await dispatch(checkExistingContactWithEmailOrPhone({ type, value })).then(res => {
            if (res && res?.contactsCount > 0) {
                toast.show({
                    title: 'Warning',
                    description: `Contact already exists with this${type === 'email' ? ' email' : ' phone number'}!`
                })
                type === 'email' ? setIsEmailContactExists(true) : setIsPhoneContactExists(true)
            } else {
                type === 'email' ? setIsEmailContactExists(false) : setIsPhoneContactExists(false)
            }
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Failed to check that contact exists or not!'
            })
            type === 'email' ? setIsEmailContactExists(true) : setIsPhoneContactExists(true)
        })
    }

    const getContactDataById = async (contactId) => {
        setIsLoading(true)
        await dispatch(getContactById({ contactId })).then(async (res) => {
            const contactData = { ...res }
            if (contactData?.status !== null) {
                contactData.status = { label: contactData.status ? 'Active' : 'In-Active', value: contactData?.status }
            } else {
                contactData.status = { label: 'Active', value: true }
            }
            if (contactData?.pronouns) {
                contactData.pronouns = getPronounsValue(contactData)
            }
            if (contactData?.phone) {
                const phone = contactData?.phone?.replaceAll(/[\s()-]+/g, '') || ''
                contactData.phone = !phone ? '' : phone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? phone : phone.startsWith('1') ? phone : '1 ' + phone
                await handlePhoneNumberFocusOut(null, null, contactData?.phone)
            }
            if (contactData?.email) {
                await handleEmailFocusOut(contactData?.email, false, false)
            }
            setContactInfo(contactData)
            setOldContactInfo(contactData)
            setIsLoading(false)
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: err?.response?.data?.message || 'Failed to get contact!'
            })
            setContactInfo(defaultValues)
            setIsLoading(false)
        })
    }

    return (
        <div className={`create-new-contact${params?.contactId ? ' padding-left' : ''}`}>
            <div class={`card${((isEdit && contactId) || params?.contactId) ? ' mb-5' : ''}`}>
                {
                    <Modal show={showLinkModal} onHide={() => { setShowLinkModal(false) }} size='md' style={{ marginTop: '40px' }}>
                        <Modal.Header>
                            <p className='text-center fs-2'>Link contact <span className='text-blue fw-bold'>{emailEntered?.value}</span> to this Supplier {supplierName || ''} ?</p>
                        </Modal.Header>
                        <Modal.Body>
                            <div className='d-flex align-items-center justify-content-center column-gap-3'>
                                <button className='report_small_button_grey' onClick={() => { saveContactHandler('cancel') }}>Cancel</button>
                                {/* <button className='report_small_button_grey' onClick={() => { setShowLinkModal(false) }}>Cancel</button> */}
                                <button className='report_small_button_success' onClick={() => { saveContactHandler('link') }}>Link</button>
                            </div>
                        </Modal.Body>
                    </Modal>
                }
                <div class="card-header bg-transparent flex-column flex-sm-row align-items-start align-items-sm-center pt-2 pb-2 h-auto">
                    <h3 className='mb-0 text-blue fw-bold'>{((isEdit && contactId) || params?.contactId) ? 'Edit Contact' : 'Add New Contact'}</h3>
                    <div className='buttons-container d-flex flex-wrap gap-3'>
                        <button
                            type="button"
                            className="fs-4 text-white rounded ps-5 pe-5 py-3 ps-sm-5 pe-sm-5 bg-gray"
                            onClick={handleCancel}
                            disabled={isLoading || isValidatingPhone | isValidatingEmail || (((isEdit && contactId) || params?.contactId) && !contactInfo?.id)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="fs-4 text-white rounded ps-5 pe-5 py-3 ps-sm-5 pe-sm-5 bg-green"
                            onClick={handleSave}
                            disabled={isLoading || isEmailContactExists || isPhoneContactExists || isValidatingPhone | isValidatingEmail || (((isEdit && contactId) || params?.contactId) && !contactInfo?.id)}
                        >
                            {((isEdit && contactId) || params?.contactId) ? 'Update' : 'Save'}
                        </button>
                    </div>
                </div>
                <div className={`card-body${isLoading ? ' position-relative loading' : ''}`}>
                    {isLoading && <LoaderComponent />}
                    <div className='card-content d-flex flex-wrap'>
                        {!isLoading && ((isEdit && contactId) || params?.contactId) && !contactInfo?.id ? (
                            <h4 className='mb-0 text-black fw-bold'>No contact found with this Id.</h4>
                        ) : (
                            columns?.map((col, index) => (
                                <div className={`d-flex gap-4 align-items-center mb-4 w-50${index % 2 === 0 ? ' pe-5' : ''}`} key={col.name}>
                                    <h4 className="label mb-0 flex-30">{col.label}: <span className="ms-1 text-danger">{col?.isRequired ? '*' : ''}</span></h4>
                                    {col?.value === 'status' || col?.value === 'pronouns' ? (
                                        <ReactSelect
                                            className="w-100 search-input payment-terms-selector ms-0 ms-sm-auto h4 mb-0 no-zIndex"
                                            options={
                                                col?.value === 'status' ? statusOptions.map((option) => (option)) : pronounsOptions.map((option) => (option))
                                            }
                                            value={contactInfo?.[col?.value] ? contactInfo?.[col?.value] : null}
                                            onChange={(options) => { handleChange(col?.value, options) }}
                                        />
                                    ) : col.value === 'phone' ?
                                        <div className="phone-input-parent flex align-center ">
                                            <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row'>
                                                <ReactPhoneInput
                                                    className={`border border-primary phone-input-parent${isPhoneContactExists ? ' bg-danger' : ''}`}
                                                    country={'us'}
                                                    value={contactInfo[col.value] || '1'}
                                                    onChange={handlePhoneInputChange}
                                                    onBlur={(event, country) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, country, contactInfo[col.value]) }}
                                                    countryCodeEditable={false}
                                                    preferredCountries={['us']}
                                                    onKeyDown={(e) => handleKeyDown(e, phoneInputRefname)}
                                                    ref={phoneInputRefname}
                                                    buttonClass='border-0 border-end border-dark'
                                                    inputProps={{
                                                        className: ` form-control border-0${isPhoneContactExists ? ' bg-danger' : ''}`,
                                                        title: isPhoneContactExists ? 'Contact already exists with this phone number!' : '',
                                                        type: 'text'
                                                    }}
                                                />
                                            </div>
                                            {isValidatingPhone && (<Loader />)}

                                            {contactInfo[col.value] && !isValidatingPhone && isPhoneValid !== '' &&
                                                (isPhoneValid ?
                                                    <BsCheckSquare color="#067911" size={26} />
                                                    :
                                                    <>
                                                        <BsXSquare color="#f75a52" size={26} />
                                                        <MdOutlineChangeCircle
                                                            title='Retry'
                                                            role='button'
                                                            color="#14438b"
                                                            size={30}
                                                            onClick={() => { handlePhoneNumberFocusOut(null, null, contactInfo[col.value], false, true) }}
                                                        />
                                                    </>
                                                )
                                            }
                                        </div>
                                        :
                                        col.value === 'email' ?
                                            <div className="phone-input-parent flex align-center">
                                                <input
                                                    className={`search-input h4 mb-0${isEmailContactExists ? ' bg-danger' : ''}`}
                                                    title={isEmailContactExists ? 'Contact already exists with this email id!' : ''}
                                                    type="text"
                                                    value={contactInfo[col.value] || ''}
                                                    onChange={e => handleChange(col.value, e.target.value)}
                                                    onBlur={() => { isEmailValid === '' && handleEmailFocusOut(contactInfo[col.value]) }}
                                                    autoComplete='no-email'
                                                />
                                                {isValidatingEmail && (<Loader />)}
                                                {contactInfo[col.value] && !isValidatingEmail && isEmailValid !== '' &&
                                                    (isEmailRisky ?
                                                        <BsCheckSquare color="#EFD700 " size={26} />
                                                        : isEmailValid ?
                                                            <BsCheckSquare color="#067911" size={26} />
                                                            :
                                                            <>
                                                                <BsXSquare color="#f75a52" size={26} />
                                                                <MdOutlineChangeCircle
                                                                    title='Retry'
                                                                    role='button'
                                                                    color="#14438b"
                                                                    size={30}
                                                                    onClick={() => { handleEmailFocusOut(contactInfo[col.value], true) }}
                                                                />
                                                            </>
                                                    )
                                                }
                                            </div> : (
                                                <input
                                                    className={`search-input h4 mb-0 `}
                                                    type="text"
                                                    value={contactInfo?.[col?.value] || ''}
                                                    onChange={e => handleChange(col?.value, e.target.value)}
                                                />
                                            )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
            {
                (contactInfo?.id && ((isEdit && contactId) || params?.contactId)) && (
                    <LinkedContactSuppliers contactId={contactId || params?.contactId} />
                )
            }
        </div >
    )
}

export default CreateContact